import bem from '../modules/bem';
import scroll from '../modules/scroll';
import utils from '../modules/utils';
import viewport from '../modules/viewport';

class RaceHeader {

	static get block() {
		return bem.block('race-header');
	}

	constructor($rh){
		this.$rh = $rh;
		this.$rhInner = this.$rh.querySelector(RaceHeader.block.selector('inner'));

		const headerSelector = this.$rh.dataset.headerSelector
									? this.$rh.dataset.headerSelector
									: bem.block('site-header').selector();

		this.$header = document.querySelector(headerSelector);

		this.activeScroll = false;
		this.fixed = false;

		this.scroll = {
			y: null
		};

		this.settings = {};

		this.init = this.init.bind(this);
		this.onResize = this.onResize.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.toggleFixed = this.toggleFixed.bind(this);
		this.updateSettings = this.updateSettings.bind(this);

		this.init();

	}

	init(){

		viewport.addListener('race-header', this.onResize);
		this.onResize();

	}

	onResize(){

		this.updateSettings();

		this.$rh.style.height = this.settings.height + 'px';

		if( this.fixed && viewport.mq('tablet-small', 'max', 'height') ){
			this.toggleFixed(false);
		}

		if( !this.activeScroll && viewport.mq('tablet-small', 'min', 'height') ){

			scroll.addListener('race-header', this.onScroll);
			this.onScroll();

			this.activeScroll = true;

		}else if( this.activeScroll && !viewport.mq('tablet-small', 'min', 'height') ){

			scroll.removeListener('race-header', this.onScroll);

			this.activeScroll = false;

		}

	}

	onScroll(){

		const scrollTop = (document.documentElement && document.documentElement.scrollTop) ||
              document.body.scrollTop;

		this.scroll.y = scrollTop;

		const isFixed = this.scroll.y > this.settings.offset;

		this.toggleFixed(isFixed);

	}

	toggleFixed(force){

		this.$rh.classList.toggle(bem.states.fixed, force);
		this.$rhInner.classList.toggle('container', force);
		this.$rhInner.style.top = `${force ? this.settings.headerHeight : 0}px`;

		this.fixed = force;

	}

	updateSettings(){

		const rhStyle = window.getComputedStyle(this.$rh, null);

		this.$rh.style.removeProperty('height');
		this.$rhInner.style.removeProperty('top');

		if (this.fixed) {
			this.$rh.classList.remove(bem.states.fixed);
		}

		this.settings.headerHeight = this.$header.offsetHeight;

		this.settings.offset = (utils.getCoords(this.$rh).top + parseInt(rhStyle.paddingTop, 10))
								- this.settings.headerHeight;

		this.settings.height = this.$rh.offsetHeight;

		if (this.fixed) {
			this.$rh.classList.add(bem.states.fixed);
		}

	}

}

module.exports = () => {
	const $raceHeader = document.querySelector(RaceHeader.block.selector());

	if( !$raceHeader ){
		return;
	}

	new RaceHeader($raceHeader); // eslint-disable-line no-new
};



// WEBPACK FOOTER //
// ./src/js/layout/race-header.js